import React from 'react'
import { Collapse } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';

const { Panel } = Collapse;


const text = `A dog is a type of domesticated animal.
Known for its loyalty and faithfulness,
it can be found as a welcome guest in many households across the world.`

export default function Faq({ type, productId }) {
    return (
        <div>
            <div className="ml-3 mr-3 my-3 p-3 md:ml-0 bg-white rounded shadow pb-3">
                <div className="mx-3 mb-3">
                    <h1 className="text-2xl font-semibold text-gray-700 border-b border-gray-200">Frequently Asked Questions</h1>
                </div>
                <div className="p-3 mt-2">
                    <Collapse
                        bordered={false}
                        ghost={true}
                        defaultActiveKey={['1']}
                        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                        className="bg-white font-normal"
                        >
                            <Panel header="This is panel header 1" key="1">
                                <p className="text-gray-600 text-sm font-light">{text}</p>
                            </Panel>
                            <Panel header="This is panel header 2" key="2">
                                <p className="text-gray-600 text-sm font-light">{text}</p>
                            </Panel>
                            <Panel header="This is panel header 3" key="3">
                                <p className="text-gray-600 text-sm font-light">{text}</p>
                            </Panel>
                    </Collapse>
                </div>
            </div>
        </div>
    )
}
